<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 14.376 14.376">
    <path
      id="Icon_Icon_Globe-2"
      d="M7.188,14.376a7.188,7.188,0,1,1,7.187-7.187A7.2,7.2,0,0,1,7.188,14.376ZM2.129,9.919a5.753,5.753,0,0,0,5.059,3.02,5.694,5.694,0,0,0,2.232-.452,1.638,1.638,0,0,0-.369-.777l-.006-.01c-.091-.138-.186-.281-.269-.427a2.536,2.536,0,0,1,.282-2.9l.072-.121a2.121,2.121,0,0,0,.206-1.051,5.34,5.34,0,0,1,.1-.987c.291-1.327,1.725-1.675,2.777-1.821a5.761,5.761,0,0,0-2.39-2.317A3.319,3.319,0,0,1,8.8,3.423a5.792,5.792,0,0,1-.634.42l-.024.014,0,0a2.07,2.07,0,0,0-.8.655A3.42,3.42,0,0,0,7.074,6.2,3.552,3.552,0,0,1,5.84,9.389a3.56,3.56,0,0,1-2.254.727A5.959,5.959,0,0,1,2.129,9.919ZM12.756,5.778c-.629.075-1.8.214-1.917.749a4.053,4.053,0,0,0-.067.727v.008a3.363,3.363,0,0,1-.407,1.729l-.073.124c-.453.759-.55.957-.27,1.443.06.106.129.21.2.311l.031.047a4.463,4.463,0,0,1,.453.814,5.687,5.687,0,0,0,2.054-5.951ZM7.188,1.437A5.722,5.722,0,0,0,1.534,8.205a5.556,5.556,0,0,0,2.038.48,2.183,2.183,0,0,0,1.383-.428c.65-.507.681-1.083.681-2.057a4.692,4.692,0,0,1,.443-2.374,3.242,3.242,0,0,1,1.33-1.2L7.44,2.6a4.494,4.494,0,0,0,.477-.313,1.9,1.9,0,0,0,.556-.7A5.709,5.709,0,0,0,7.188,1.437Z"
      transform="translate(0)"
    />
  </svg>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GlobeIcon extends Vue {}
</script>

<style>
</style>